// extracted by mini-css-extract-plugin
module.exports = {"icon":"ChatImagesUploader__icon____yoDn","disabled":"ChatImagesUploader__disabled___22DKb"};